import React, { Component } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import Avatar from "react-avatar";
import styles from "../styles/components/header.module.scss";
import DropLogOut from "./DropLogOut";

class AvatarLiveli extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false
    };
  }

  render() {
    const { name, fsize, signOut } = this.props;
    const { isActive } = this.state;
    return (
      <OutsideClickHandler
        onOutsideClick={() => {
          if (this.state.isActive === true) {
            this.setState({ isActive: !isActive });
          }
        }}
      >
        <Avatar
          onClick={() => this.setState({ isActive: !isActive })}
          style={{ fontSize: `${fsize}` }}
          className={styles.__avatar}
          unstyled
          name={name}
        />
        <DropLogOut visible={isActive} signOut={signOut} />
      </OutsideClickHandler>
    );
  }
}

export default AvatarLiveli;
